import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { resolveAttachmentUrl } from '../functions/resolve-attachment-url';

@Pipe({
  name: 'appendDomain',
  standalone: true,
})
export class AppendDomainPipe implements PipeTransform {
  private readonly devDomain = 'https://dev.ccomx.app/';

  transform(link?: string): string {
    if (!link || link.indexOf('http') !== -1 || link.startsWith('data:image')) {
      return link || '';
    }

    if (this.isLocalhost()) {
      if (this.isRemoteDev()) {
        return this.prependDomain(this.devDomain, link);
      }
      return resolveAttachmentUrl(link, environment.apiUrl);
    }

    return link;
  }

  private isLocalhost(): boolean {
    return window.location.hostname === 'localhost';
  }

  private isRemoteDev(): boolean {
    return environment.environmentName === 'remote-development';
  }

  private prependDomain(domain: string, link: string): string {
    return `${domain}${link}`;
  }
}
